import JoditEditor from 'jodit-react';
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import Switch from '@mui/material/Switch';
import routes from "../../react_routes_enum";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState, useRef } from "react";
import getImageUrls from "../../api/uploadImageOnS3";
import { useDispatch, useSelector } from "react-redux";
import LoaderIcon from "../../components/loader/Loader";
import { validateUniv } from "../../utils/vaildateUniv";
import UploadBox from '../../components/UploadBox/UploadBox';
import { removeEmptyKeys } from "../../utils/removeEmptyKeys";
import { getAvailableExams } from "../../redux/students/studentsSlice";
import { MenuItem, Button, TextField, InputLabel, Select } from "@mui/material";
import { getConfigDetails } from "../../redux/configurationDetails/configDetailsSlice";
import { getCoachingById, updateCoachingData } from '../../redux/coaching/coachingSlice';

const useStyles = makeStyles( theme => ({
    formInputLabel:{
        color: '#000 !important',
        fontSize: '18px !important',
        marginBottom: '4px',
        fontWeight: 'bold !important'
    },
    addMore: {
        background: '#F69220 !important',
        marginTop: '12px !important',
        color: '#FFF !important',
        textTransform: 'capitalize !important',
        borderRadius: '4px !important',
        "&:hover":{
            background: '#F69220',
        }
    },
    submitBtn: {
        width: '100%',
        color: '#FFF !important',
        height: '40px !important',
        minHeight: '40px !important',
        marginTop: '12px !important',
        textTransform: 'capitalize !important',
        borderRadius: '4px !important',
        "&:hover":{
            background: '#F69220',
        }
    },
    marginBot24: {
        marginBottom: '24px'
    }
}))

const courseType = {
    description: "",
    feeStructure: [
        {
            fees: "",
            exam: "",
            image: "",
            category: "",
            duration: "",
            discount: "",
            teaching_mode: "",
            min_qualification: ""
        }
    ]
}
const placementType = {
    description: "",
    record: [
        {
            year: "",
            exam: "",
            totalSelected: ""
        }
    ]
}
const campusType = {
    description: "",
    hostelFees: "",
    facilities: "",
    warden: [
        {
            name: "",
            warden: "",
            phone: ""
        }
    ]
}
const admissionType = {
    description: "",
    course: [
        {
            name: "",
            keyPoints: []
        }
    ]
}

const data = {
    rank: 0,
    type: "",
    discount: 0,
    brochure: "",
    is_top: false,
    study_mode: "",
    category: "",
    approved_by: "",
    scholarships: "",
    exams: courseType,
    sub_description: "",
    selection: placementType,
    institute: campusType,
    admission: admissionType,
    course_tought: []
}
const CoachingEditForm = () => {
    const classes = useStyles();
    const editor = useRef(null);
    const naviagte = useNavigate();
    const dispatch = useDispatch();
    
    const [errors, setErrors] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(data);
    const [btnLoader, setBtnLoader] = useState(false);
    const [universityCat, setUniversityCat] = useState([]);
    const [admissionKeyPoints, setAdmissionKeyPoints] = useState("");

    const { availableExamData } = useSelector((state) => state.students);
    const { isLoading, coachingId } = useSelector((state) => state.coaching);

    useEffect(() => {
        const res = dispatch(getAvailableExams({limit: 50, offset: 0}));
        res?.then((r) => {
            if(r.payload.message === "unauthorized" || 
                r.payload.message === "Unauthorized" ||
                r.payload.message === "Session Expired"){
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                naviagte(routes.LOGIN);
            }
        })
    }, [dispatch]);

    useEffect(() => {
        const res = dispatch(getConfigDetails());
        res.then((r) => {
            if(r?.payload?.data){
                r?.payload?.data?.map((item) => {
                    if(item.configuration_type === "university_category"){
                        setUniversityCat(item?.data)
                    }
                })
            }
        })
    }, [])

    useEffect(() => {
        if(!coachingId) naviagte(-1)
        let res = dispatch(getCoachingById({coachingId}));
        res?.then((r) => {
            if(r?.payload?.statusCode === 200){
                setFormData({ 
                    rank: r?.payload?.data?.rank ?? 0,
                    type: r?.payload?.data?.type ?? "",
                    discount: r?.payload?.data?.discount ?? 0,
                    brochure: r?.payload?.data?.brochure ?? "",
                    is_top: r?.payload?.data?.is_top ?? false,
                    study_mode: r?.payload?.data?.study_mode ?? "",
                    category: r?.payload?.data?.category ?? "",
                    approved_by: r?.payload?.data?.approved_by ?? "",
                    sub_description: r?.payload?.data?.sub_description ?? "",
                    exams: r?.payload?.data?.exams ?? courseType,
                    selection: r?.payload?.data?.selection ?? placementType,
                    scholarships: r?.payload?.data?.scholarships ?? "",
                    institute: r?.payload?.data?.institute ?? campusType,
                    admission: r?.payload?.data?.admission ?? admissionType,
                    course_tought: r?.payload?.data?.course_tought ?? []
                })
                return;
            }
            if(r?.payload?.message.toLowerCase() === "unauthorized" || 
                r?.payload?.message === "Session Expired"){
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                naviagte(routes.LOGIN);
            }
        })
    }, [coachingId]);

    const handleChange = (e) => {
        e.target.name === "isTop" && setFormData({...formData, is_top: e.target.checked});
        e.target.name === "rank" && setFormData({...formData, rank: e.target.value});
        e.target.name === "discount" && setFormData({...formData, discount: e.target.value});
        e.target.name === "type" && setFormData({...formData, type: e.target.value});
        e.target.name === "study_mode" && setFormData({...formData, study_mode: e.target.value});
        e.target.name === "approved_by" && setFormData({...formData, approved_by: e.target.value});
        e.target.name === "sub_description" && setFormData({...formData, sub_description: e.target.value});
        e.target.name === "category" && setFormData({...formData, category: e.target.value});
    }

    const handlePlacementChange = (e) => {
        if(e.target.name === "placement_description"){
            setFormData({
                ...formData, 
                selection: {
                    ...formData.selection, 
                    description: e.target.value
                }
            });
            return;
        }
        let array = [...formData?.selection?.record];
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(e.target.name === `year_${ind}` && {year: e.target.value}),
                ...(e.target.name === `exam_${ind}` && {exam: e.target.value}),
                ...(e.target.name === `total_selected_${ind}` && {totalSelected: e.target.value})
            }
        })
        setFormData({
            ...formData,
            selection: {
                ...formData.selection,
                record: [...array]
            }
        });
    }

    const handleCourseChange = async (e) => {
        let value = "";
        let category = "";
        const fileInput = e.target.name?.split("_")[0];
        if(e.target.name === "course_description"){
            setFormData({
                ...formData,
                courses: {
                    ...formData.courses,
                    description: e.target.value
                }
            });
            return;
        }
        if(fileInput === "file"){
            value = await uploadImage(e);
        }
        let array = [...formData?.exams?.feeStructure];
        if(fileInput === "course"){
            let newArray = availableExamData?.filter((item) => item.name === e.target.value);
            const matchingExam = array.filter(item => item.exam === newArray[0]?.exam);
            if(matchingExam && matchingExam?.length > 0) return toast.error("Exam Already Added");
            if(newArray){
                category = newArray[0]?.category;
            }
        }
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(e.target.name === `course_${ind}` && {exam: e.target.value, category}),
                ...(e.target.name === `fees_${ind}` && {fees: e.target.value}),
                ...(e.target.name === `studymode_${ind}` && {teaching_mode: e.target.value}),
                ...(e.target.name === `duration_${ind}` && {duration: e.target.value}),
                ...(e.target.name === `file_${ind}` && {image: value}),
                ...(e.target.name === `discount_${ind}` && {discount: e.target.value}),
                ...(e.target.name === `min_qualification_${ind}` && {min_qualification: e.target.value}),
            }
        })
        const examNames = array.map(item => item.exam);
        setFormData({
            ...formData,
            course_tought: examNames,
            exams: {
                ...formData.exams,
                feeStructure: [...array]
            }
        });
    }

    const uploadImage = async (e) => {
        if(e.target.files[0]?.type !== "image/png" &&
            e.target.files[0]?.type !== "image/jpeg"){
            toast.error("Invalid file type");
            return "";
        }
        if(e.target.files[0]?.size > 1049000){
            toast.error("Image size must be less than 1MB");
            return "";
        }
        const response = await getImageUrls({
            image: e.target.files[0],
            setLoading,
            setErrors,
        });
        return response?.data?.urls[0];
    }

    // const handleScholarshipChange = (e) => {
    //     let array = [...formData?.scholarships];
        
    //     array = array.map((element, ind) => {
    //         let arrayData = [];
    //         if((ind === Number(e.target.name.split("_")[1])) && 
    //             (e.target.name.split("_")[0] === "benefit")){
    //             arrayData = element?.benefits;
    //             arrayData.push(e.target.value);
    //         }
    //         if((ind === Number(e.target.name.split("_")[1])) && 
    //             (e.target.name.split("_")[0] === "eligibility")){
    //             arrayData = element?.eligibility;
    //             arrayData.push(e.target.value);
    //         }
    //         return {
    //             ...element,
    //             ...(e.target.name === `name_${ind}` && {name: e.target.value}),
    //             ...(e.target.name === `benefit_${ind}` && {benefits: [...arrayData]}),
    //             ...(e.target.name === `eligibility_${ind}` && {eligibility: [...arrayData]})
    //         }
    //     })

    //     setFormData({
    //         ...formData,
    //         scholarships: [...array]
    //     });
    // }

    const handleAdmissionChange = (e) => {
        if(e.target.name === "admission_description"){
            setFormData({
                ...formData, 
                admission: {
                    ...formData.admission, 
                    description: e.target.value
                }
            });
            return;
        }
        let array = [...formData?.admission?.course];
        array = array.map((element, ind) => {
            let arrayData = [];
            if((ind === Number(e.target.name.split("_")[2])) &&
                (e.target.name.split("_")[0] === "admission")){
                arrayData = element?.keyPoints;
                arrayData.push(e.target.value);
            }
            return {
                ...element,
                ...(e.target.name === `course_${ind}` && {name: e.target.value}),
                ...(e.target.name === `admission_keypoints_${ind}` && {keyPoints: [...arrayData]})
            }
        })
        setFormData({
            ...formData,
            admission: {
                ...formData.admission,
                course: [...array]
            }
        });
    }

    const handleCampusChange = (e) => {
        if(e.target.name === "campus_description"){
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    description: e.target.value
                }
            });
            return;
        }
        if(e.target.name === "campus_hostel_fees"){
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    hostelFees: e.target.value
                }
            });
            return;
        }
        if(e.target.name === "campus_hostel_facilities"){
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    facilities: e.target.value
                }
            });
            return;
        }
        let array = [...formData?.institute?.warden];
        array = array.map((element, ind) => {
            return {
                ...element,
                ...(e.target.name === `name_${ind}` && {name: e.target.value}),
                ...(e.target.name === `warden_${ind}` && {warden: e.target.value}),
                ...(e.target.name === `phone_${ind}` && {phone: e.target.value})
            }
        })
        setFormData({
            ...formData,
            institute: {
                ...formData.institute,
                warden: [...array]
            }
        });
    }

    const submit = () => {
        const status = validateUniv(formData);
        if(status.isValid){
            const body = removeEmptyKeys(formData)
            setBtnLoader(true);
            const res = dispatch(updateCoachingData({
                body,
                id: coachingId
            }));
            res?.then((r) => {
                setBtnLoader(false);
                r?.payload?.statusCode === 200 ? 
                    toast.success("Data Updated Successfully") :
                    toast.error(r?.payload?.message)
            })
        }
        else{
            toast.error(status.message);
        }
    }

    const handleUploadChange = (name, value) => {
        setFormData({...formData, brochure: value});
    }

    const addMore = (text, arrayData) => {
        let array = [...arrayData];
        if(text === "selection"){
            array.push({
                year: "",
                exam: "",
                totalSelected: ""
            });
            setFormData({
                ...formData,
                selection: {
                    ...formData.selection,
                    record: [...array]
                }
            })
        }
        if(text === "courseFee"){
            array.push({
                fees: "",
                exam: "",
                duration: "",
                image: ""
            });
            setFormData({
                ...formData,
                exams: {
                    ...formData.exams,
                    feeStructure: [...array]
                }
            })
        }
        if(text === "warden"){
            array.push({
                name: "",
                warden: "",
                phone: ""
            });
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    warden: [...array]
                }
            })
        }
        if(text === "admission"){
            array.push({
                name: "",
                keyPoints: []
            });
            setFormData({
                ...formData,
                admission: {
                    ...formData.admission,
                    course: [...array]
                }
            })
        }
    }

    const handleRemove = (text, arrayData, index) => {
        let array = [...arrayData];
        if(text === "selection"){
            if(array?.length === 1){
                return;
            }
            array.splice(index, 1);
            setFormData({
                ...formData,
                selection: {
                    ...formData.selection,
                    record: [...array]
                }
            })
        }
        if(text === "courseFee"){
            if(array?.length === 1){
                return;
            }
            array.splice(index, 1);
            setFormData({
                ...formData,
                exams: {
                    ...formData.exams,
                    feeStructure: [...array]
                }
            })
        }
        if(text === "warden"){
            if(array?.length === 1){
                return;
            }
            array.splice(index, 1);
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    warden: [...array]
                }
            })
        }
        if(text === "admission"){
            if(array?.length === 1){
                return;
            }
            array.splice(index, 1);
            setFormData({
                ...formData,
                admission: {
                    ...formData.admission,
                    course: [...array]
                }
            })
        }
    }

    const removeNestedItem = (text, index, ind, arrayItem) => {
        let array = [...arrayItem];
        array.splice(ind, 1);
        if(text === "keyPoints"){
            setFormData({
                ...formData,
                admission: {
                    ...formData?.admission,
                    course: formData?.admission?.course.map((item, indx) => {
                        if(indx === index){
                            return {
                                ...item,
                                keyPoints: [...array]
                            };
                        }
                        return { ...item };
                    })
                }
            });
        }

    }

    const handleAdmissionKeyDown = (event) => {
        if (event.key === "Enter") {
            handleAdmissionChange(event);
            setAdmissionKeyPoints("");
        }
    }

    const handleEditorChange = (type, value) => {
        
        if(type === "exams"){
            setFormData({
                ...formData,
                exams: {
                    ...formData.exams,
                    description: value
                }
            });
            return
        }
        if(type === "scholarships"){
            setFormData({
                ...formData,
                scholarships: value
            });
            return
        }
        if(type === "selection"){
            setFormData({
                ...formData, 
                selection: {
                    ...formData.selection,
                    description: value
                }
            });
            return
        }
        if(type === "campus"){
            setFormData({
                ...formData,
                institute: {
                    ...formData.institute,
                    description: value
                }
            });
            return
        }
        if(type === "admission"){
            setFormData({
                ...formData, 
                admission: {
                    ...formData.admission, 
                    description: value
                }
            });
            return
        }

    }

    return (
        <div style={{marginTop: '3%'}}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
                className={classes.marginBot24}
            >
                <InputLabel className={classes.formInputLabel}>
                    Is It New Coaching ?
                </InputLabel>
                <Switch
                    name="isTop"
                    defaultChecked
                    onChange={handleChange}
                    checked={formData.is_top}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Discount
                    </InputLabel>
                    <TextField
                        type="number"
                        placeholder=""
                        name="discount"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        onChange={handleChange}
                        value={formData.discount}
                    />
                </div>
                {/* <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Type
                    </InputLabel>
                    <Select
                        label=""
                        name="type"
                        sx={{ width: '100%' }}
                        value={formData?.type}
                        onChange={handleChange}
                        labelId="demo-simple-select-label_1"
                    >
                        <MenuItem value="Private">Private</MenuItem>
                        <MenuItem value="Government">Government</MenuItem>
                        <MenuItem value="Semi-Government">Semi-Government</MenuItem>
                    </Select>
                </div> */}
                <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Sub Description
                    </InputLabel>
                    <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        name="sub_description"
                        onChange={handleChange}
                        value={formData?.sub_description}
                    />
                </div>
                <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Study Mode
                    </InputLabel>
                    <Select
                        label=""
                        name="study_mode"
                        sx={{ width: '100%' }}
                        onChange={handleChange}
                        value={formData?.study_mode}
                        labelId="demo-simple-select-label_2"
                    >
                        <MenuItem value="Online">Online</MenuItem>
                        <MenuItem value="Offline">Offline</MenuItem>
                        <MenuItem value="Both">Both</MenuItem>
                    </Select>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Rank
                    </InputLabel>
                    <TextField
                        name="rank"
                        type="number"
                        placeholder=""
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        onChange={handleChange}
                        value={formData.rank}
                    />
                    {/* <div className={classes.marginBot24} style={{width: '32%'}}>
                        <InputLabel className={classes.formInputLabel}>
                            Sub Description
                        </InputLabel>
                        <TextField
                            type="text"
                            variant="outlined"
                            sx={{
                                width: '100%',
                                height: '62px'
                            }}
                            name="sub_description"
                            onChange={handleChange}
                            value={formData?.sub_description}
                        />
                    </div> */}
                    {/* <div className={classes.marginBot24} style={{width: '32%'}}>
                        <InputLabel className={classes.formInputLabel}>
                            Category
                        </InputLabel>
                        <Select
                            label=""
                            name="category"
                            sx={{ width: '100%' }}
                            onChange={handleChange}
                            value={formData?.category}
                            labelId="demo-simple-select-label_2"
                        >
                            {universityCat?.map((item, index) => (
                                <MenuItem value={item?.cat} key={index}>
                                    {item?.cat}
                                </MenuItem>
                            ))}
                        </Select>
                    </div> */}
                </div>
                <div className={classes.marginBot24} style={{width: '32%'}}>
                    <InputLabel className={classes.formInputLabel}>
                        Approved By
                    </InputLabel>
                    <TextField
                        type="text"
                        name="approved_by"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        onChange={handleChange}
                        value={formData?.approved_by}
                    />
                </div>
                <div className={classes.marginBot24} style={{width: '32%'}}></div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Brochure
                </InputLabel>
                <UploadBox
                    width="220px"
                    height="194px"
                    name="brochour-upload"
                    value={formData?.brochure}
                    handleUpload={(name, value) => handleUploadChange(name, value)}
                />
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Selection Details
                </InputLabel>
                <div
                    style={{
                        padding: '12px',
                        borderRadius: '6px',
                        border: '1px solid'
                    }}
                >
                    <InputLabel className={classes.formInputLabel}>
                        Description
                    </InputLabel>
                    {/* <TextField
                        type="text"
                        placeholder=""
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        name="placement_description"
                        onChange={handlePlacementChange}
                        value={formData?.placement?.description}
                    /> */}
                    <div style={{marginBottom: '8px'}}>
                        <JoditEditor 
                            ref={editor}
                            value={formData?.selection?.description}
                            onChange={(e) => handleEditorChange("selection", e)}
                        />
                    </div>
                    {formData?.selection?.record?.map((item, index) => (
                        <div key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.formInputLabel}>
                                    Record {index + 1}
                                </InputLabel>
                                <Button
                                    type="button"
                                    onClick={() => handleRemove("selection", formData?.selection?.record, index)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Year
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item.year}
                                        name={"year_"+index}
                                        onChange={handlePlacementChange}
                                    />
                                </div>
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Exam
                                    </InputLabel>
                                    <Select
                                        label=""
                                        value={item?.exam}
                                        name={"exam_"+index}
                                        sx={{ width: '100%' }}
                                        onChange={handlePlacementChange}
                                        labelId="demo-simple-select-label_2"
                                    >
                                        {availableExamData && 
                                            availableExamData?.map((item, index) => (
                                            <MenuItem value={item?.name} key={index}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Total Selected Students
                                    </InputLabel>
                                    <TextField
                                        type="number"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.totalSelected}
                                        name={"total_selected_"+index}
                                        onChange={handlePlacementChange}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    <Button
                        type="button"
                        className={classes.addMore}
                        onClick={() => addMore("selection", formData?.selection?.record)}
                    >
                        Add More Record
                    </Button>
                </div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Exams
                </InputLabel>
                <div
                    style={{
                        padding: '12px',
                        borderRadius: '6px',
                        border: '1px solid'
                    }}
                >
                    <InputLabel className={classes.formInputLabel}>
                        Description
                    </InputLabel>
                    <div style={{marginBottom: '8px'}}>
                        <JoditEditor 
                            ref={editor}
                            value={formData?.exams?.description}
                            onChange={(e) => handleEditorChange("exams", e)}
                        />
                    </div>
                    {formData?.exams?.feeStructure?.map((item, index) => (
                        <div key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.formInputLabel}>
                                    Exam {index + 1}
                                </InputLabel>
                                <Button
                                    type="button"
                                    onClick={() => handleRemove("courseFee", formData?.exams?.feeStructure, index)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Exam
                                    </InputLabel>
                                    <Select
                                        label=""
                                        value={item?.exam}
                                        name={"course_"+index}
                                        sx={{ width: '100%' }}
                                        onChange={handleCourseChange}
                                        labelId="demo-simple-select-label_2"
                                    >
                                        {availableExamData && 
                                            availableExamData?.map((item, index) => (
                                            <MenuItem value={item?.name} key={index}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Study Mode
                                    </InputLabel>
                                    <Select
                                        label=""
                                        sx={{ width: '100%' }}
                                        name={"studymode_"+index}
                                        value={item?.teaching_mode}
                                        onChange={handleCourseChange}
                                        labelId="demo-simple-select-label_2"
                                    >
                                        <MenuItem value="Online">Online</MenuItem>
                                        <MenuItem value="Offline">Offline</MenuItem>
                                        <MenuItem value="Live Classes">Live Classes</MenuItem>
                                        <MenuItem value="Crash Courses">Crash Courses</MenuItem>
                                        <MenuItem value="Certification Courses">Certification Courses</MenuItem>
                                    </Select>
                                </div>
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Fees
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.fees}
                                        name={"fees_"+index}
                                        onChange={handleCourseChange}
                                        
                                    />
                                </div>
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Discount(%)
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.discount}
                                        name={"discount_"+index}
                                        onChange={handleCourseChange}
                                        
                                    />
                                </div>
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Duration
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.duration}
                                        name={"duration_"+index}
                                        onChange={handleCourseChange}
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Min Qualification
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        onChange={handleCourseChange}
                                        value={item?.min_qualification}
                                        name={"min_qualification_"+index}
                                    />
                                </div>
                                <div style={{width: '19%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Image
                                    </InputLabel>
                                    {loading ? 
                                        <LoaderIcon/> : 
                                        <input
                                            type="file"
                                            sx={{
                                                width: '100%',
                                                height: '62px'
                                            }}
                                            name={"file_"+index}
                                            onChange={handleCourseChange}
                                        />
                                    }
                                    {item?.image && 
                                        <p
                                            style={{
                                                marginTop: '4px',
                                                fontSize: '14px'
                                            }}
                                        >
                                            {item?.image?.split("-")[3]}
                                        </p>
                                    }
                                </div>
                                <div style={{width: '19%'}}></div>
                                <div style={{width: '19%'}}></div>
                                <div style={{width: '19%'}}></div>
                            </div>
                        </div>
                    ))}
                    <Button
                        type="button"
                        className={classes.addMore}
                        onClick={() => addMore("courseFee", formData?.exams?.feeStructure)}
                    >
                        Add More Exam
                    </Button>
                </div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Scholarships
                </InputLabel>
                <div
                    style={{
                        padding: '12px',
                        border: '1px solid',
                        borderRadius: '6px'
                    }}
                >
                    {/* <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        value={item?.name}
                        name={"name_"+index}
                        onChange={handleScholarshipChange}
                    /> */}
                    <InputLabel className={classes.formInputLabel}>
                        Scholarships Description
                    </InputLabel>
                    <JoditEditor 
                        ref={editor}
                        value={formData?.scholarships}
                        onChange={(e) => handleEditorChange("scholarships", e)}
                    />
                    {/* {formData?.scholarships?.map((item, index) => (
                        <div key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.formInputLabel}>
                                    Scholarship {index + 1}
                                </InputLabel>
                                <Button
                                    type="button"
                                    onClick={() => handleRemove("scholarship", formData?.scholarships, index)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                            <div>
                                <InputLabel className={classes.formInputLabel}>
                                    Name
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={item?.name}
                                    name={"name_"+index}
                                    onChange={handleScholarshipChange}
                                />
                            </div>
                            <div>
                                <InputLabel className={classes.formInputLabel}>
                                    Eligibility&nbsp;
                                    <span className="optional-text">
                                        ( Press enter to add )
                                    </span>
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={eligibility}
                                    name={"eligibility_"+index}
                                    onKeyDown={(e) => handleKeyDown(e)}
                                    onChange={(e) => setEligibility(e.target.value)}
                                />
                                {item?.eligibility?.map((itm, ind) => (
                                    <div
                                        key={ind}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            {ind+1}.&nbsp;
                                            <p style={{margin: 0}}>
                                                {itm}
                                            </p>
                                        </div>
                                        <Button
                                            type="button"
                                            onClick={() => removeNestedItem("eligibility", index, ind, item?.eligibility)}
                                        >
                                            <CloseIcon />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                            <div>
                                <InputLabel className={classes.formInputLabel}>
                                    Benefits&nbsp;
                                    <span className="optional-text">
                                        ( Press enter to add )
                                    </span>
                                </InputLabel>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    sx={{
                                        width: '100%',
                                        height: '62px'
                                    }}
                                    value={benefits}
                                    name={"benefit_"+index}
                                    onKeyDown={(e) => handleKeyDown(e)}
                                    onChange={(e) => setBenefits(e.target.value)}
                                />
                                {item?.benefits?.map((itm, ind) => (
                                    <div
                                        key={ind}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            {ind+1}.&nbsp;
                                            <p style={{margin: 0}}>
                                                {itm}
                                            </p>
                                        </div>
                                        <Button
                                            type="button"
                                            onClick={() => removeNestedItem("benefits", index, ind, item?.benefits)}
                                        >
                                            <CloseIcon />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                    <Button
                        type="button"
                        className={classes.addMore}
                        onClick={() => addMore("scholarship", formData?.scholarships)}
                    >
                        Add More Scholarship
                    </Button> */}
                </div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Institute Detail
                </InputLabel>
                <div
                    style={{
                        padding: '12px',
                        borderRadius: '6px',
                        border: '1px solid'
                    }}
                >
                    <InputLabel className={classes.formInputLabel}>
                        Description
                    </InputLabel>
                    {/* <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        name="campus_description"
                        onChange={handleCampusChange}
                        value={formData?.campus?.description}
                    /> */}
                    <div style={{marginBottom: '8px'}}>
                        <JoditEditor 
                            ref={editor}
                            value={formData?.institute?.description}
                            onChange={(e) => handleEditorChange("campus", e)}
                        />
                    </div>
                    <InputLabel className={classes.formInputLabel}>
                        Hostel Fees
                    </InputLabel>
                    <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        name="campus_hostel_fees"
                        onChange={handleCampusChange}
                        value={formData?.institute?.hostelFees}
                    />
                    <InputLabel className={classes.formInputLabel}>
                        Facilities&nbsp;
                        <span className="optional-text">
                            ( Use [ , ] to enter more values )
                        </span>
                    </InputLabel>
                    <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        onChange={handleCampusChange}
                        name="campus_hostel_facilities"
                        value={formData?.institute?.facilities}
                    />
                    {formData?.institute?.warden?.map((item, index) => (
                        <div key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.formInputLabel}>
                                    Warden {index + 1}
                                </InputLabel>
                                <Button
                                    type="button"
                                    onClick={() => handleRemove("warden", formData?.institute?.warden, index)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Name
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.name}
                                        name={"name_"+index}
                                        onChange={handleCampusChange}
                                    />
                                </div>
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Warden
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.warden}
                                        name={"warden_"+index}
                                        onChange={handleCampusChange}
                                    />
                                </div>
                                <div style={{width: '32%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Phone
                                    </InputLabel>
                                    <TextField
                                        type="number"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={item?.phone}
                                        name={"phone_"+index}
                                        onChange={handleCampusChange}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    <Button
                        type="button"
                        className={classes.addMore}
                        onClick={() => addMore("warden", formData?.institute?.warden)}
                    >
                        Add More Warden
                    </Button>
                </div>
            </div>
            <div className={classes.marginBot24}>
                <InputLabel className={classes.formInputLabel}>
                    Admission Requirements
                </InputLabel>
                <div
                    style={{
                        padding: '12px',
                        borderRadius: '6px',
                        border: '1px solid'
                    }}
                >
                    <InputLabel className={classes.formInputLabel}>
                        Description
                    </InputLabel>
                    {/* <TextField
                        type="text"
                        variant="outlined"
                        sx={{
                            width: '100%',
                            height: '62px'
                        }}
                        name="admission_description"
                        onChange={handleAdmissionChange}
                        value={formData?.admission?.description}
                    /> */}
                    <div style={{marginBottom: '8px'}}>
                        <JoditEditor 
                            ref={editor}
                            value={formData?.admission?.description}
                            onChange={(e) => handleEditorChange("admission", e)}
                        />
                    </div>
                    {formData?.admission?.course?.map((item, index) => (
                        <div key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.formInputLabel}>
                                    Exam {index + 1}
                                </InputLabel>
                                <Button
                                    type="button"
                                    onClick={() => handleRemove("admission", formData?.admission?.course, index)}
                                >
                                    <CloseIcon />
                                </Button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{width: '49%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Exam Name
                                    </InputLabel>
                                    
                                    <Select
                                        label=""
                                        value={item?.name}
                                        name={"course_"+index}
                                        sx={{ width: '100%' }}
                                        onChange={handleAdmissionChange}
                                        labelId="demo-simple-select-label_2"
                                    >
                                        {availableExamData && 
                                            availableExamData?.map((item, index) => (
                                            <MenuItem value={item?.name} key={index}>
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                                <div style={{width: '49%'}}>
                                    <InputLabel className={classes.formInputLabel}>
                                        Requirements&nbsp;
                                        <span className="optional-text">
                                            ( Press enter to add )
                                        </span>
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        sx={{
                                            width: '100%',
                                            height: '62px'
                                        }}
                                        value={admissionKeyPoints}
                                        name={"admission_keypoints_"+index}
                                        onKeyDown={(e) => handleAdmissionKeyDown(e)}
                                        onChange={(e) => setAdmissionKeyPoints(e.target.value)}
                                    />
                                </div>
                            </div>
                            {item?.keyPoints?.map((itm, ind) => (
                                <div
                                    key={ind}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        {ind+1}.&nbsp;
                                        <p style={{margin: 0}}>
                                            {itm}
                                        </p>
                                    </div>
                                    <Button
                                        type="button"
                                        onClick={() => removeNestedItem("keyPoints", index, ind, item?.keyPoints)}
                                    >
                                        <CloseIcon />
                                    </Button>
                                </div>
                            ))}
                        </div>
                    ))}
                    <Button
                        type="button"
                        className={classes.addMore}
                        onClick={() => addMore("admission", formData?.admission?.course)}
                    >
                        Add More Exam
                    </Button>
                </div>
            </div>
            <Button
                type="button"
                onClick={submit}
                disabled={btnLoader}
                className={classes.submitBtn}
                style={{backgroundColor: btnLoader ? 'rgb(197 196 196)' : '#672F8F'}}
            >
                {btnLoader ? <LoaderIcon/> : <span>Submit</span>}
            </Button>
        </div>
    )
}
export default CoachingEditForm;